import script from "./FaceGuideOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceGuideOverlay.vue?vue&type=script&setup=true&lang=js"

import "./FaceGuideOverlay.vue?vue&type=style&index=0&id=6f973da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f973da0"]])

export default __exports__